module.exports = __webpack_public_path__ + "img/imagen1.002de9e8.png";